import React from 'react';
import { useSelector } from 'react-redux';
import { dataForLicenseDisplay } from 'software_renewal/redux/selectors';

const ViewMateEssentialsPromoSection = () => {
  const licenseInfo = useSelector(dataForLicenseDisplay);
  const { products } = licenseInfo;

  if (!licenseInfo?.products?.length) {
    return null;
  }

  if (!products.some(({ product }) => product.name === 'ViewMate Deluxe')) {
    return null;
  }

  return (
    <div className="viewmate-essentials-promo-section container-fluid px-0">
      <div className="container-fluid container-xl">
        <div className="row">
          <div className="col-12">
            <div className="announcement-banner">
              <h1 className="announcement-title font-heavy d-flex align-items-center justify-content-center">
                <img src={Spree.image_assets.announcement_icon} alt="Announcement Icon" className="mr-2" />
                Important Announcement
              </h1>
              <h2 className="announcement-subtitle font-heavy">
                ViewMate Deluxe has been retired to make way <br className="d-none d-md-block" /> for our next-generation CAM software.
              </h2>
            </div>
            <p className="announcement-description text-center font-heavy">
              Your perpetual license will remain fully functional without
              interruption; however, no further versions will be released. We
              will continue to provide support by phone or email until your
              maintenance contract expires.
            </p>
          </div>

          <div className="col-12 col-lg-8 upgrade-section">
            <div className="upgrade-header">
              <h3 className="upgrade-title font-heavy">
                Step into the Future!
              </h3>
              <p className="upgrade-description font-medium">
                With ViewMate Deluxe now retired, this is the perfect time to
                <br className="d-none d-md-block" />
                upgrade to ViewMate Essentials, our next-generation CAM software,
                <br className="d-none d-md-block" />
                offering enhanced tools such as:
              </p>
            </div>
          </div>
          <div className="col-12 col-lg-6 upgrade-section">
            <ul className="features-list">
              <li className="feature-item">
                <div className="feature-icon">
                  <img src={Spree.image_assets.cam_editor} alt="CAM Editor" />
                </div>
                <div className="feature-content d-flex flex-row align-items-center">
                  <div className="feature-text d-flex flex-row flex-wrap align-items-center">
                    <h4 className="feature-title font-heavy mr-2">
                      CAM Editor
                    </h4>
                    <span className="feature-description">
                      for Gerber files and drill data
                    </span>
                  </div>
                </div>
              </li>

              <li className="feature-item">
                <div className="feature-icon">
                  <img src={Spree.image_assets.smart_dfm} alt="Smart DFM" />
                </div>
                <div className="feature-content d-flex flex-row justify-content-between align-items-center">
                  <div className="feature-text d-flex flex-row flex-wrap align-items-center">
                    <h4 className="feature-title font-heavy mr-2">Smart DFM</h4>
                    <span className="feature-description">
                      with custom rule checks
                    </span>
                  </div>
                  <span className="new-badge font-heavy">New</span>
                </div>
              </li>

              <li className="feature-item">
                <div className="feature-icon">
                  <img
                    src={Spree.image_assets.pcb_navigator}
                    alt="PCB Navigator"
                  />
                </div>
                <div className="feature-content d-flex flex-row justify-content-between align-items-center">
                  <div className="feature-text d-flex flex-row flex-wrap align-items-center">
                    <h4 className="feature-title font-heavy mr-2">PCB Navigator</h4>
                    <span className="feature-description">
                      with views and reports
                    </span>
                  </div>
                  <span className="new-badge font-heavy">New</span>
                </div>
              </li>
            </ul>

            <div className="pcb-navigator-box">
              <p className="description">
                <span className="title">PCB Navigator</span> is a specialized
                software tool that &quot;adds intelligence&quot; to your static
                Gerber files by integrating them with your Bill of Materials and
                XY Data, turning them into an interactive, searchable
                environment for inspection, troubleshooting, and documentation.
              </p>
            </div>
            <div className="mt-5">
              <a
                href="/viewmate-essentials"
                className="learn-more-btn px-4 py-3"
              >
                Learn More
              </a>
            </div>
          </div>

          <div className="col-12 col-lg-6">
            <div className="image-wrapper position-relative">
              <div className="background-overlay">
                <img
                  loading="lazy"
                  src={Spree.image_assets.pcb_navigator_gif}
                  className="foreground-image img-fluid position-relative"
                  alt="ViewMate Essentials Software Box"
                />
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-12">
            <div className="subscription-section">
              <div className="row align-items-center">
                <div className="software-box-image">
                  <img
                    src={Spree.image_assets.viewmate_essentials}
                    alt="ViewMate Essentials Software Box"
                  />
                </div>
                <div className="col-12">
                  <div className="subscription-content">
                    <p className="subscription-title">
                      <span className="font-medium">ViewMate Essentials</span>{' '}
                      is offered as a subscription license for{' '}
                      <span className="font-heavy">$195 per year</span>,
                      including full customer support and continuous software
                      updates.
                    </p>
                    <p className="subscription-text">
                      As a valued ViewMate Deluxe customer, you are entitled to
                      a <span className="font-heavy">50% discount</span> on your first subscription license. If your
                      maintenance is still active, you will also receive an
                      additional prorated discount based on your renewal date.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewMateEssentialsPromoSection;
